import classNames from 'classnames';

type Props = {
    onClick?: React.MouseEventHandler;
    children?: React.ReactNode;
    style?: React.CSSProperties;
    className?: string;
};
export function ToolbarItem({ className, style, ...props }: Props) {
    return (
        <button
            {...props}
            inert={!props.children ? '' : undefined}
            type="button"
            className={classNames(
                'flex items-center justify-center',
                className,
            )}
            style={{
                height: '48px',
                width: '48px',
                ...style,
            }}
        />
    );
}
